// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"styles_sectionTitle__2Nuc5","sectionTitleWithoutOver":"styles_sectionTitleWithoutOver__3V5VG","sectionTitlePolicy":"styles_sectionTitlePolicy__2Hp4u"};